import React from "react";
import "./EventReviewDisplayResume.css";

const EventReviewDisplayResume = ({ reviews }) => {
  const contentResume = (review) => {
    return (
      <div className="review-container" key={review.id}>
        <h1 className="review-title">{review.title}</h1>
        <div>
          <text className="review-name">{review.username}</text>
          <text className="review-date-resume">{review.dateFeedback}</text>
        </div>
        <p className="review-comment">{review.text}</p>
      </div>
    );
  };

  const emptyResume = "Nessun feedback disponibile. Condividi il tuo parere e aiutaci a crescere!";

  return (
    <div>
      {reviews && reviews.length > 0 ? (
        <>
          {reviews
            .sort((a, b) => a.dateFeedback.localeCompare(b.dateFeedback))
            .map((review) => contentResume(review))}
        </>
      ) : (
        <p>{emptyResume.toUpperCase()}</p>
      )}
    </div>
  );
};

export default EventReviewDisplayResume;
